import { Injectable } from '@angular/core';
import { AudioSource } from './audio-source';
import { environment } from '../../../../../environments/environment';
import { Show } from '../../../../services/archive.model';
import { BehaviorSubject } from 'rxjs';
import { PlayerTimes } from './player.model';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  public currentlyPlaying = new BehaviorSubject<Show>(null);
  public times = new BehaviorSubject<PlayerTimes>(null);
  public isPlaying = new BehaviorSubject<boolean>(false);
  public showingInfo = new BehaviorSubject<boolean>(false);

  constructor(public audio: AudioSource) {
    audio.addEventListener('timeupdate', ($event: Event) => this.onTimeUpdate($event));
  }

  get volume(): number {
    return Math.floor(this.audio.volume * 100);
  }

  set volume(volume: number) {
    this.audio.volume = volume / 100;
  }

  play(url?: string): void {
    this.showingInfo.next(false);

    if (url) {
      this.audio.src = url;
    }

    const promise: any = this.audio.play();

    if (promise && promise.catch) {
      promise.catch(() => {
      });
    }

    this.isPlaying.next(true);
  }

  pause(): void {
    this.audio.pause();
    this.isPlaying.next(false);
  }

  seekByPercent(percent: number): void {
    this.seek(this.times.value.duration / 100 * percent);
  }

  seek(time: number): void {
    this.audio.currentTime = time;
  }

  playFromArchive(show: Show): void {
    const url = environment.soundcloudApiUrl + '/tracks/' + show.soundcloud_upload_id +
      '/stream?client_id=' + environment.soundcloudClientId;

    this.currentlyPlaying.next(show);

    this.isPlaying.next(true);
    //this.play(url);
  }

  playLivestream(): void {
    this.unsetSource();

    this.currentlyPlaying.next(null);

    if (this.audio.canPlayType('mp3')) {
      this.play(environment.streamMp3Url);
    } else {
      this.play(environment.streamOgaUrl);
    }
  }

  toggleInfo(): void {
    this.showingInfo.next(!this.showingInfo.value);
  }

  private unsetSource(): void {
    this.audio.srcObject = null;
  }

  private onTimeUpdate($event: Event): void {
    const { buffered, currentTime, duration } = $event.target as HTMLAudioElement;
    const bufferedTime = buffered.length ? buffered.end(0) : 0;

    this.times.next({
      bufferedTime,
      currentTime,
      duration,
      percentBuffered: `${(bufferedTime / duration * 100) || 0}%`,
      percentCompleted: `${(currentTime / duration * 100) || 0}%`
    });
  }
}
